import { Card, Col, Row, Container } from "react-bootstrap"
import { totalBeneficiarios } from "./customersUtils";

export default function CustomersDashboardCards({ customers }) {

    return (
        <Container fluid className="mt-4 mb-5">
            <Row className="mb-4">

                <Col md={3}>
                    <Card className="shadow-sm">
                        <Card.Body>
                            <h6>Customers Ativos</h6>
                            <h3>{customers.filter(item => item.ativo !== false).length}</h3>
                        </Card.Body>
                    </Card>
                </Col>

                <Col md={3}>
                    <Card className="shadow-sm">
                        <Card.Body className="row">
                            <div className="col col-6">
                                <h6>Pessoas Físicas</h6>
                                <h3>{customers.filter(item => item.tipo_pessoa === "F").length}</h3>
                            </div>
                            <div className="col col-6">
                                <h6>Pessoas Jurídicas</h6>
                                <h3>{customers.filter(item => item.tipo_pessoa === "J").length}</h3>
                            </div>
                        </Card.Body>
                    </Card>
                </Col>

                <Col md={3}>
                    <Card className="shadow-sm">
                        <Card.Body>
                            <h6>Total de Beneficiários</h6>
                            <h3>{customers.reduce((soma, item) => soma + totalBeneficiarios(item), 0)}</h3>
                        </Card.Body>
                    </Card>
                </Col>

                <Col md={3}>
                    <Card className="shadow-sm">
                        <Card.Body>
                            <h6>Customers sem Beneficiários</h6>
                            <h3>{customers.filter(item => totalBeneficiarios(item) === 0).length}</h3>
                        </Card.Body>
                    </Card>
                </Col>

            </Row>
        </Container>
    )

}
